import React from 'react'
import { func, string, bool } from 'prop-types'
import { Button, Icon, Form, TextInput } from '@cobalt/cobalt-react-components'
import SecureForm from '../../components/SecureForm'
import NoRecaptchaSecureForm from '../../components/NoRecaptchaSecureForm'

class DisableMFAForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false
    }
  }

  handleShowPassword = () =>
    this.setState({ showPassword: !this.state.showPassword })

  handlePasswordChange = event => {
    const password = event.target.value
    this.props.onFormChange(password)
  }

  renderForm = (onConfirm, formLabel, formPlaceholder) => (
    <Form>
      <Form.FieldGroup label={formLabel}>
        <TextInput
          tabIndex={'0'}
          autoFocus
          type={
            this.state.showPassword
              ? TextInput.TYPE_TEXT
              : TextInput.TYPE_PASSWORD
          }
          placeholder={formPlaceholder}
          onChange={this.handlePasswordChange}
        />
        <Button
          secondary
          normal
          onClick={this.handleShowPassword}
          onConfirm={onConfirm}
          tabIndex="-1"
        >
          <Icon
            name={
              this.state.showPassword ? Icon.VISIBILITY_OFF : Icon.VISIBILITY
            }
            tiny
          />
        </Button>
      </Form.FieldGroup>
    </Form>
  )

  render() {
    const {
      onConfirm,
      onExecuteRecaptcha,
      confirmText,
      formLabel,
      formPlaceholder,
      isFormValid,
      isMFARevokeInProgress,
      siteKey
    } = this.props
    return (
      <React.Fragment>
        {this.renderForm(onConfirm, formLabel, formPlaceholder)}
        {siteKey !== '' ? (
          <SecureForm
            siteKey={siteKey}
            submitLabel={confirmText}
            onSubmit={onConfirm}
            onExecuteRecaptcha={onExecuteRecaptcha}
            isFormValid={isFormValid}
            disabledForm={isMFARevokeInProgress}
            isDanger={true}
          />
        ) : (
          <NoRecaptchaSecureForm
            disabledForm={isMFARevokeInProgress}
            onSubmit={onConfirm}
            isFormValid={isFormValid}
            submitLabel={confirmText}
            isDanger={true}
          >
            <React.Fragment></React.Fragment>
          </NoRecaptchaSecureForm>
        )}
      </React.Fragment>
    )
  }
}

DisableMFAForm.propTypes = {
  onFormChange: func.isRequired,
  onConfirm: func.isRequired,
  onExecuteRecaptcha: func.isRequired,
  confirmText: string.isRequired,
  formLabel: string.isRequired,
  formPlaceholder: string.isRequired,
  isMFARevokeInProgress: bool.isRequired,
  isFormValid: bool.isRequired,
  siteKey: string.isRequired
}

export default DisableMFAForm
